import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";

import Title from "@/components/ui/title/title.jsx";
import ComponentSearch from "@/components/search/search.jsx";
import Grid from "@/components/ui/grid/grid.jsx";
import Card from "@/components/ui/card/card.jsx";
import FormValidSearch from "@/components/form-valid-search/form-valid-search.jsx";
import LatestNews from "@/components/latest-news/latest-news.jsx";
import bcAll from "@/components/breadcrumb-app/breadcrumb-context.jsx";

const useBreadcrumb = bcAll.useBreadcrumb;

const Search = () => {
  const [isValidSearch, setIsValidSearch] = useState(false)
  const [termSearch, setTermSearch] = useState("")
  const location = useLocation()
  const {setLabel} = useBreadcrumb();
  
  useEffect(() => {
    // Atualiza o título do documento
    document.title = 'Mobilidade - Pesquisa';
    // Util.updateActiveLink();
    setLabel("search", "Pesquisa");
  }, [])
  
  useEffect(() => {
    try {
      let queryParams = null
      if (location.search) queryParams = new URLSearchParams(location.search)
      if (queryParams?.get('term')) {
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setTermSearch(queryParams?.get('term'));
        setIsValidSearch(true);
        
        setTimeout(() => {
          const input = document.querySelector('input[data-testid="combobox-input"]');
          if (!input) return false;
          input.value = queryParams.get('term');
          const event = new Event("input", {bubbles: true});
          input.dispatchEvent(event);
        }, 1000);
      }
    } catch (error) {
      console.log('Ocorreu um erro ao tentar verificar os parâmetros passados. %s', error);
    }
  }, [location])
  
  return (
    <div>
      <FormValidSearch formTitle="Para onde vamos?" inputPlaceholder="" focus={Object.keys(new URLSearchParams(location.search)).length > 0}/>
      <div>
        {
          (isValidSearch && termSearch) ? (
              <>
                <Title type="h3" classX={" text-body-secondary"}>
                  <span className={"fs-3 fw-semibold"} style={{fontFamily: "inherit"}}>Resultados</span>
                </Title>
                <ComponentSearch value={termSearch}/>
              </>
            ) :
            (
              <>
                <Title title="Nada encontrado..." classX={" text-body-secondary mb-3"}/>
                <Grid>
                  <Card title="Os resultados aparecem aqui" subtitle="">
                    Digite um termo para pesquisar. Pode ser o nome de uma rua, de um bairro, de uma linha de ônibus, etc. A pesquisa é feita em tempo real.
                  </Card>
                </Grid>
              </>
            )
        }
        <div style={{marginTop: '4rem'}}>
          <LatestNews/>
        </div>
      </div>
    </div>
  );
}

export default Search;
